import React from "react";
import {
  compose,
  withHandlers,
  withStateHandlers,
  withPropsOnChange,
} from "recompose";
import {
  Page,
  TableContainer,
  withTable,
  Pagination,
  TableSearch,
  ViewingRecords,
} from "components/common";
import { XeroTableDataFetch } from "components";
import { Link, useHistory } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import { Button, Table } from "reactstrap";
import { keys, compact, filter, includes } from "lodash";
import qs from "query-string";
import { Trans } from "react-i18next";
import setOffset from "../ContactGroups/List";

import { withSelectedOrganisation } from "../../components/withSelectedOrganisation";
import { withContactGroups } from "../../components/withContactGroups";
import BackButton from "components/refactoring/BackButton";
import { useOrganisationContext } from "hooks";

export const UsersList = ({
  selected,
  setSelected,
  ordering,
  setOrdering,
  data,
  url,
  setData,
  limit,
  offset,
  refreshToken,
  xeroFilters,
  match,
  search,
  setSearch,
  title,
  user,
}) => {
  const history = useHistory()

  const { selectedOrganisation } = useOrganisationContext()

  const handleInviteClick = (user) => {
    const { EmailAddress, FirstName, LastName } = user;

    const inviteUrl = `/userslist/new?email=${EmailAddress}&first_name=${FirstName}&last_name=${LastName}`;
    window.open(inviteUrl);
    console.log(user)
  };

  return (
      <Page title={title || "Xero Connected Users"}>
      <BackButton/>
      <a className="my-3 float-left mb-2 btn btn-primary" 
         href="https://go.xero.com/Setup/Users.aspx" 
         target="_blank" 
         rel="noopener noreferrer">
        <span className="fa fa-plus mr-1" />
         <Trans>Invite User In Xero Organization</Trans>
      </a>
      <div className="my-4 small inv-table">
        <TableContainer
          items={data.results}
          ordering={ordering}
          idKey="UserID"
          onOrderingChanged={setOrdering}
          selected={selected}
          onSelectedChanged={setSelected}
        >
          <Table size="sm" className="small">
            <thead>
              <tr>
                <th className="text-left" /*sortBy="Name"*/>
                  <Trans>Name</Trans>
                </th>
                <th className="text-left" /*sortBy="EmailAddress"*/>
                  <Trans>Email</Trans>
                </th>
                <th /*sortBy="OrganisationRole"*/>
                  <Trans>User Role</Trans>
                </th>
                <th /*sortBy="UserID"*/>
                  <Trans>Last Updated</Trans>
                </th>
                <th /*sortBy="IsSubscriber"*/>
                  <Trans>Xero Account</Trans>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {data.loading && (
                <tr>
                  <td colSpan="7" className="text-center">
                    <span className="fa fa-spinner fa-spin mt-2" />{" "}
                    <Trans>Loading...</Trans>
                  </td>
                </tr>
              )}
              {data.results.map((i) => (
                <tr key={i.UserID}>
                  <td className="text-left">
                    <Link>{capital(i.FirstName)} {capital(i.LastName)}</Link>
                  </td>
                  <td className="text-left">{i.EmailAddress}</td>
                  <td>{renderModelNames(i.OrganisationRole)}</td>
                  <td>{formatDate(i.UpdatedDateUTC)}</td>
                  <td>{i.IsSubscriber ? (<span className="fa fa-check-circle text-success"> Subscriber</span>) : (<span>User</span>)}</td>
                  <td>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => handleInviteClick(i)}
                    >
                      <Trans>Invite User</Trans>
                    </button>
                  </td>
                  {/*<td className="text-end">
                    <Link to={`${match.url}/${i.UserID}/details`}>
                      <Trans>Details</Trans>
                      </Link>
                    </td>*/}
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableContainer>
        </div>
    {xeroFilters && (
      <XeroTableDataFetch
        ordering={ordering}
        refreshToken={refreshToken}
        filters={xeroFilters}
        limit={limit}
        url={url}
        offset={offset}
        onDataFetched={setData}
      />
    )}

    <div className="clearfix">
      <div className="float-right">
        <Pagination
          size="sm"
          noPages
          limit={limit}
          offset={offset}
          onOffsetChanged={setOffset}
        />
      </div>
      <ViewingRecords
        offset={offset}
        limit={limit}
        noCount
        className="float-left"
      />
    </div>
  </Page>
)};

const renderModelNames = (name) => {
  const customNames = {
      "READONLY": "Read Only",
      "INVOICEONLY": "Invoice Only",
      "STANDARD": "Standard",
      "FINANCIALADVISER": "Financial Adviser",
      "MANAGEDCLIENT": "Managed Client",
      "CASHBOOKCLIENT": "Cashbook Client",
  };

  return customNames[name] || name;
};

const formatDate = (dateString) => {
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);

  const [day, month, year] = formattedDate.split(' ');

  const dayWithSuffix = addDaySuffix(parseInt(day, 10));

  return `${dayWithSuffix} ${month} ${year}`;
};

const addDaySuffix = (day) => {
  if (day >= 11 && day <= 13) {
    return `${day}th`;
  }

  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
};

const capital = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const enhance = compose(
  withStateHandlers(
    {
      url: "users",
    },
    {
      setState: () => (state) => ({ ...state }),
      setError: () => (error) => ({ error }),
    }
  ),
  withPropsOnChange(
    (props, next) => props.location.search !== next.location.search,
    ({ location, xero, setState }) => {
      const q = qs.parse(location.search);

      if (q.userGroup) {
        xero.get(`usergroups/${q.userGroup}`).then((userGroup) => {
          setState({
            userGroup: userGroup,
          });
        });
      } else {
        setState({ userGroup: null });
      }
    }
  ),
  withTable({
    limit: 100,
  }),
  withPropsOnChange(
    ["search", "user_ids", "location", "offset"],
    ({ search, user_ids, location, setState, offset, setLimit }) => {
      let { userGroup } = qs.parse(location.search);
      let limit = 100;
      if (userGroup) {
        limit = 20;
      }
      setLimit(limit);

      const input = (search || "").replace(/"/g, "").toLowerCase();
      let params = {};
      const raw = [];

      if (!!input) {
        raw.push(
          `(Name.ToLower().Contains("${input}") OR (EmailAddress != null AND EmailAddress.ToLower().Contains("${input}")))`
        );
        params.search = input;
      }
      if (!!user_ids) {
        let ids = user_ids.slice(offset, limit + offset);
        if (ids.length === 0) {
          ids = [userGroup];
        }
        params["extra_params"] = {
          IDs: user_ids ? ids.join(",") : null,
        };
        params.user_ids = user_ids ? ids.join(",") : "";
      } else if (userGroup) {
        return;
      }

      params.raw = compact(raw).join(" AND ");
      setState({ xeroFilters: params });

      return {
        title: userGroup ? `Users in ${userGroup.Name}` : "Xero Connected Users",
      };
    }
  ),
  withSelectedOrganisation(),
  withContactGroups(),
  withHandlers({
    addSelectedUsersToGroup:
      ({ xero, selected, selectedOrganisation, t }) =>
      (userGroup) => {
        xero
          .post(
            `usergroups/${userGroup.UserGroupID}/users`,
            keys(selected).map((x) => ({ UserID: x }))
          )
          .then((resp) =>
            NotificationManager.success(
              t("Added {{count}} users to {{userGroup.Name}}", {
                count: keys(selected).length,
                userGroup,
              })
            )
          );
      },
    removeSelectedUsersFromGroup: 
      ({
        xero,
        selected,
        selectedOrganisation,
        setState,
        xeroFilters,
        t,
        user_ids,
      }) =>
      (userGroup) => {
      setState({ removePending: true });
        let urls = keys(selected).map(
          (x) => `usergroups/${userGroup.UserGroupID}/users/${x}`
        );
        Promise.all(urls.map((x) => xero.delete(x)))
          .then((resp) => {
            NotificationManager.success(
              t("Removed {{ count }} users from {{ userGroup.Name }}", {
                count: keys(selected).length,
                userGroup,
              })
            );
            let newUserIds = filter(
              [...user_ids],
              (x) => !includes(keys(selected), x)
            );
            if (newUserIds.length === 0) {
              newUserIds = [userGroup.UserGroupID];
            }
            setState({ user_ids: newUserIds });
          })
          .finally(() => {
            setState({ removePending: false });
          });
      },
    onArchived:
      ({ setState, xeroFilters, t }) =>
      (failed) => {
        NotificationManager.success(t("Archive successful"));
        setState({ xeroFilters: { ...xeroFilters } });
      },
  })
);

export default enhance(UsersList);